var map = {
	"./de-DE/txt_wp-6times.png": "8155",
	"./en-GB/txt_wp-6times.png": "07f0",
	"./en-US/txt_wp-6times.png": "0a34",
	"./es-ES/txt_wp-6times.png": "0c88",
	"./es-MX/txt_wp-6times.png": "f4b5",
	"./fr-CA/txt_wp-6times.png": "993e",
	"./fr-FR/txt_wp-6times.png": "bdd2",
	"./it-IT/txt_wp-6times.png": "8d5c",
	"./ja-JP/txt_wp-6times.png": "a0c0",
	"./pt-BR/txt_wp-6times.png": "3ebb",
	"./zh-TW/txt_wp-6times.png": "132b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ba0c";